import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import styles from './ToggleViewControl.styles';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';
import { cx } from '@emotion/css';
import { ViewMode } from '@/config/constants';
import { useViewModeContext } from '@/context/ViewModeContext';
import { TrackingFrom, useAnalytics } from '@/hooks';
import { TrackingEvents, TrackingStage } from '@/config/tracking';

interface Props {
  trackingFrom: TrackingFrom;
}

export const ToggleViewControl: React.FC<Props> = ({ trackingFrom }) => {
  const { viewMode, setViewMode } = useViewModeContext();
  const { trackEvent } = useAnalytics();

  const handleChange = (event: React.SyntheticEvent, newValue: ViewMode | null) => {
    if (newValue !== null) {
      setViewMode(newValue);
      trackEvent({
        event: TrackingEvents.filterFlyerSet,
        event_detail: `${newValue}_view`,
        stage: TrackingStage.discovery,
        ...trackingFrom,
      });
    }
  };

  return (
    <div className={styles.container} role="group" aria-label="View mode selector">
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={handleChange}
        aria-label="Choose view mode"
        orientation="horizontal"
      >
        <ToggleButton
          value="grid"
          className={cx(styles.button, styles.buttonLeft)}
          aria-label="Grid view"
          aria-pressed={viewMode === 'grid'}
        >
          <AppsOutlinedIcon className={styles.icon} aria-hidden="true" />
        </ToggleButton>
        <ToggleButton
          value="list"
          className={cx(styles.button, styles.buttonRight)}
          aria-label="List view"
          aria-pressed={viewMode === 'list'}
        >
          <ViewAgendaOutlinedIcon className={styles.icon} aria-hidden="true" />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
